import * as React from 'react';

import Button from 'common/components/core/Button/Button';
import type { DialogProps } from 'common/components/core/Dialog/Dialog';
import Dialog from 'common/components/core/Dialog/Dialog';

export type SessionExpiredDialogProps = DialogProps & {
  onLogin?: () => void;
  disableLoginAction?: boolean;
};

/**
 * The SessionExpiredDialog.
 *
 * Displays a dialog that notifies the user that the session has expired and allows them
 * to log back in or log out completely.
 */
export default function SessionExpiredDialog(props: SessionExpiredDialogProps) {
  return (
    <Dialog
      className="session-expired-dialog"
      isOpen={props.isOpen}
      onClose={props.onClose}
      title="Logged out"
      cancelButtonText="Leave"
      actions={
        props.disableLoginAction ? null : (
          <Button htmlType="submit" onClick={props.onLogin}>
            Log back in
          </Button>
        )
      }
    >
      You have been logged out due to inactivity.
    </Dialog>
  );
}
